import { NgIf, AsyncPipe } from '@angular/common'
import { Component } from '@angular/core'
import { ParagraphComponent } from '@spartacus/storefront'

@Component({
  selector: 'eb-copy-right',
  templateUrl: './eb-copy-right.component.html',
  styleUrls: ['./eb-copy-right.component.scss'],
  standalone: false
})
export class EbCopyRightComponent extends ParagraphComponent {}
